<div class="page-header">
    <div>
        <h4 class="section-title">Test chat</h4>
        <p class="page-subtitle">Same runtime as the website widget. Works on DRAFT agents and is not counted in the customer's usage.</p>
    </div>
    <div class="flex-spacer"></div>
    <button *ngIf="conversationId && perms.has(P.conversationGet)" class="btn-light btn-sm btn-inline" (click)="openConversation()">
        <i class="fa-solid fa-list"></i> Open conversation
    </button>
    <button class="btn-light btn-sm btn-inline" (click)="newConversation()" [disabled]="lines.length === 0 && !conversationId">
        <i class="fa-solid fa-rotate"></i> New conversation
    </button>
</div>

<div class="chat-log" #log>
    <div *ngIf="lines.length === 0" class="chat-empty">
        <i class="fa-solid fa-comment-dots"></i>
        <div *ngIf="agent.welcomeMessage" class="bubble assistant" dir="auto">{{ agent.welcomeMessage }}</div>
        <div class="muted">Write a message to start a test conversation.</div>
    </div>
    <div *ngFor="let l of lines" class="line" [ngClass]="l.role.toLowerCase()">
        <div *ngIf="l.role === 'NOTE'; else bubbleLine" class="note" dir="auto" role="status"><i class="fa-solid fa-book-open"></i> {{ l.text }}</div>
        <ng-template #bubbleLine>
        <div class="bubble" [ngClass]="l.role.toLowerCase()" dir="auto">{{ l.text }}<span *ngIf="l.streaming" class="cursor"></span></div>
        <div class="meta" *ngIf="l.role === 'ASSISTANT' && !l.streaming">
            <span *ngIf="l.usage?.inputTokens !== undefined">in {{ l.usage?.inputTokens }} / out {{ l.usage?.outputTokens }} tokens</span>
            <span *ngIf="l.ms !== undefined"> · {{ l.ms | number }} ms</span>
        </div>
        </ng-template>
    </div>
</div>

<div class="chat-input">
    <textarea [(ngModel)]="text" (keydown)="onKeydown($event)" rows="3" dir="auto" [maxlength]="maxChars"
        placeholder="Type a message. Enter sends, Shift+Enter adds a line." [disabled]="busy"></textarea>
    <div class="chat-actions">
        <span class="muted">{{ text.length }} / {{ maxChars }}</span>
        <button *ngIf="busy" class="btn-danger btn-sm btn-inline" (click)="stop()"><i class="fa-solid fa-stop"></i> Stop</button>
        <button *ngIf="!busy" class="btn-primary btn-inline" (click)="send()" [disabled]="!text.trim()">
            <i class="fa-solid fa-paper-plane"></i> Send
        </button>
    </div>
</div>
<p class="muted" *ngIf="conversationId">Conversation <span class="mono">{{ conversationId }}</span></p>
